<app-nav></app-nav>
<section class="status" >
  <div class="container" id="claimRegistrationList" *ngIf="!checkStatusDetails">
    <div class="col text-center">
      <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/eclaims-status/check-status-illustrartion.png" alt="">
      <p class="title mt-4 ">Claim Registration Number</p>
      <div class="sum-insured-input">
          <div class="form-group">
              <select class="form-control" name="intimation" id="intimationNumber"
                  [(ngModel)]="selectedIntimation" #intimation="ngModel" required>
                  <option disabled selected value="" >Select Intimation Number</option>
                  <option [ngValue]="intimationNumber" *ngFor="let intimationNumber of intimationList">{{intimationNumber}}</option>
              </select>
              <div *ngIf="intimation.invalid && intimation.touched " class="error-message">
                  <div *ngIf="intimation.errors.required">
                      Claim Registration number is required.
                  </div>
              </div>
          </div>
      </div>
      <div class="col text-center mt-4">
        <button type="button" class="btn btn-bordered-blue" id="checkStatus" (click)="getClaimDetailByIntimationNo1();">
          Check Status
        </button>
      </div>
    </div>
  </div>

 
</section>